module.exports = __webpack_public_path__ + "img/ht.1b37c845.svg";